import { render, staticRenderFns } from "./id.vue?vue&type=template&id=a0c6db24&scoped=true"
import script from "./id.vue?vue&type=script&lang=js"
export * from "./id.vue?vue&type=script&lang=js"
import style0 from "./id.vue?vue&type=style&index=0&id=a0c6db24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c6db24",
  null
  
)

export default component.exports